const React = require('react');

const {FormWrapper} = require('../../../../../../FormHandlers');
const UserRegistrationFooter = require('../../../UserRegistrationFooter');
const schemaOwner = require('../../utils/schemaOwner').default;
const OwnerFields = require('../OwnerFields');

module.exports = ({data: rawData, activeUserId, otherOwnersShares, resetUserData, onSubmit, onNextStep}) => {

  const {identity_doc_data, address_doc_data, ...data} = rawData;

  return (
    <FormWrapper
      data={{
        ...data,
        owner_document_identity: identity_doc_data,
        owner_document_address: address_doc_data
      }}
      schema={{default: schemaOwner(otherOwnersShares || 0)}}
      onSubmit={onSubmit}
      onResult={resetUserData}
      resultModalData={[
        !!rawData.full_name
          ? `Owner ${rawData.full_name} updated`
          : 'New owner added'
      ]}
    >
      {(formCtx) => {
        return (
          <>
            <OwnerFields
              activeUserId={activeUserId}
              formCtx={formCtx}
            />
            <UserRegistrationFooter
              submitBtnProps={{formCtx}}
              nextStepBtnProps={{onClick: onNextStep}}
            />
          </>
        )
      }}
    </FormWrapper>
  )
}
